<template>
  <div class="CooperationUnit">
    <div class="main">
      <p class="title">产投研合作单位</p>
      <p class="sub_title">聚集产业链上、中、下游各端企事业单位，充分发挥产、学、研、政、中、金、用等各方优势
        带动相关地区金融大数据应用领域的持续发展</p>

      <ul class="items">
        <li class="item" v-for="item,index in items">
          <p class="num">{{item.num}}</p>
          <p class="name">{{item.name}}</p>
        </li>
      </ul>

      <div class="units banks">
        <p class="title">银行</p>
        <ul>
          <li>
            <img src="../../assets/imgs/img-home-co-13.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-14.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-15.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-16.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-17.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-18.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-19.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-20.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-21.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-22.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-23.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-24.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-01.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-02.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-03.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-10.png" />
          </li>
        </ul>
      </div>

      <div class="units financialInstitutions">
        <p class="title">金融机构</p>
        <ul>
          <li>
            <img src="../../assets/imgs/img-home-co-05.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-06.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-07.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-08.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-09.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-04.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-11.png" />
          </li>
          <li>
            <img src="../../assets/imgs/img-home-co-12.png" />
          </li>
        </ul>
      </div>

      <div class="units insurances">
        <p class="title">保险</p>
        <ul>
          <li>
            <img src="../../assets/imgs/25.png" />
          </li>
          <li>
            <img src="../../assets/imgs/26.png" />
          </li>
          <li>
            <img src="../../assets/imgs/27.png" />
          </li>
          <li>
            <img src="../../assets/imgs/28.png" />
          </li>
          <li>
            <img src="../../assets/imgs/29.png" />
          </li>
          <li>
            <img src="../../assets/imgs/30.png" />
          </li>
          <li>
            <img src="../../assets/imgs/31.png" />
          </li>
          <li>
            <img src="../../assets/imgs/32.png" />
          </li>
          <li>
            <img src="../../assets/imgs/33.png" />
          </li>
        </ul>
      </div>

      <div class="units scientificInstitutions">
        <p class="title">科研机构</p>
        <ul>
          <li>
            <img src="../../assets/imgs/ic-suda.png" />
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'CooperationUnit',
  data () {
    return {
      items: [
        {num:"16+",name:"银行"},
        {num:"8+",name:"金融机构"},
        {num:"1+",name:"科研机构"},
      ]
    }
  },
  mounted() {
    var screenHeight =  document.documentElement.clientHeight
    setTimeout(function() {
      window.onscroll = function() {
        var bool = $(window).scrollTop()+$(window).height()==$(document).height();
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        let fontSize = getComputedStyle(window.document.documentElement)['font-size'];

        var lis = $('.CooperationUnit ul li')
        for(var i =0;i<lis.length;i++) {
          var offsetTop = $(lis[i]).offset().top
          if(offsetTop - scrollTop - screenHeight < 0 && !bool && !$(lis[i]).hasClass('active')) {
            $(lis[i]).addClass('active')
          }
        }
      }
    },100)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" type="text/scss">
  @import '../../assets/css/animation.css';
  .CooperationUnit {
    width: 100%;
    display: inline-block;
    background:rgba(244,244,244,1);
    padding-bottom: 90px;

    .main {
      width: 1200px;
      margin: 0 auto;
      p {
        margin: 0;
      }
      >.title {
        height:50px;
        font-size:40px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
        margin-top: 59px;
      }
      >.sub_title {
        width: 738px;
        font-size:18px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
        margin: 29px auto 52px;
      }

      .items {
        margin: 0;
        display: flex;
        justify-content: center;
        text-align: center;
        padding: 0;

        .item {
          width: 186px;
          height: 186px;
          border-radius: 50%;
          list-style: none;
          float: left;
          margin: 0 55px;
          background-color: #4196FF;
          color: #fff;
          position: relative;
          opacity: 0;
          transform:RotateY(90deg);
          -ms-transform:RotateY(90deg); 	/* IE 9 */
          -moz-transform:RotateY(90deg); 	/* Firefox */
          -webkit-transform:RotateY(90deg); /* Safari 和 Chrome */
          -o-transform:RotateY(90deg); 	/* Opera */
          &.active{
            -moz-animation: RotateY 0.5s linear forwards;
            -ms-animation: RotateY 0.5s linear forwards;
            -webkit-animation: RotateY 0.5s linear forwards;
            -o-animation: RotateY 0.5s linear forwards;
            animation: RotateY 0.5s linear forwards;
          }
          p{
            text-align: center;
          }
          .num {
            height:65px;
            font-size:60px;
            font-family:PingFangSC-Heavy;
            font-weight:800;
            color:#fff;
            line-height:60px;
            margin-top: 45px;
          }
          .name {
            height:40px;
            font-size:28px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:#fff;
            line-height:40px;
          }
        }
      }

      .units {
        width: 1000px;
        background-color: #fff;
        margin: 0 auto;
        border-radius: 6px;
        padding-bottom: 20px;

        &.banks {
          margin-top: 50px;
        }
        &.financialInstitutions {
          margin-top: 20px;
        }
        &.insurances {
          margin-top: 20px;
        }
        &.scientificInstitutions {
          margin-top: 20px;
        }

        .title {
          height:75px;
          font-size:28px;
          font-family:PingFangSC-Medium;
          font-weight:500;
          color:rgba(0,0,0,1);
          line-height:70px;
          padding-left: 34px;
        }
        ul {
          display: -webkit-flex; /* Safari */
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          flex-direction: row;
          padding: 0;
          margin: 0;

          li {
            width:208px;
            height:80px;
            list-style: none;
            margin-left: 34px;
            margin-bottom: 16px;
            float: left;
            transform:RotateY(90deg);
            -ms-transform:RotateY(90deg); 	/* IE 9 */
            -moz-transform:RotateY(90deg); 	/* Firefox */
            -webkit-transform:RotateY(90deg); /* Safari 和 Chrome */
            -o-transform:RotateY(90deg); 	/* Opera */
            &.active{
              -moz-animation: RotateY 0.5s linear forwards;
              -ms-animation: RotateY 0.5s linear forwards;
              -webkit-animation: RotateY 0.5s linear forwards;
              -o-animation: RotateY 0.5s linear forwards;
              animation: RotateY 0.5s linear forwards;
            }

            img {
              width: 100%;
              border-radius:8px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Big_Data/CooperationUnit.vue